<template>
      <div no-body class="lku-benefitEnttl"> 
      <b-row v-if="lkuLoading" class="justify-content-center mb-2"><span style="color:blue;">Loading data ...</span></b-row>
      <b-row v-else>
        <b-col lg="10">
              <b-row>
                <b-col md="6">
                    <b-input-group >
                        <b-input-group-prepend><label >Employee</label></b-input-group-prepend>
                        <b-form-input v-model="tblData.crewname" placeholder="Name" :disabled="((tblData.crewkey||'') !== '')" @keyup.13.native="refresh()"></b-form-input>
                    </b-input-group>
                </b-col>
                <b-col md="6">
                  <b-input-group >
                      <b-input-group-prepend><span class="mt-2" >Benefit Name</span></b-input-group-prepend>                  
                        <b-form-input v-model="tblData.NmClaim" placeholder="Name" :disabled="((tblData.ClaimID||'') !== '')" @keyup.13.native="refresh()"></b-form-input>
                  </b-input-group>
                </b-col>
              </b-row>       
        </b-col>
        <b-col lg="2">
                  <b-button variant="success" size="sm" @click="refresh()" > <i class="fa fa-refresh"></i> Apply Filter</b-button>
                  <b-button class="btn btn-secondary" size="sm" @click="clearFilter()" > <i class="fa fa-eraser"></i>Clear Filter</b-button>
        </b-col>
      </b-row>

      <b-table
        class="mb-0"
        ref="tblAdvPay" style="font-size:smaller;" 
        responsive small striped hover
        :items="tblData.items"
        :fields="fields"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="updatetable" 
        @row-clicked="selectItem"
      >
        <template v-slot:cell(TotPlatform)="data">
          {{data.item.TotPlatform | numFormat}}
        </template>
        <template v-slot:cell(TotalTaken)="data">
          {{data.item.TotalTaken | numFormat}}
        </template>
        <template v-slot:cell(PlatfrmBlc)="data">
          {{data.item.PlatfrmBlc | numFormat}}
        </template>
      </b-table>

        <b-row>
          <b-col cols="6">
            <div>
              Page {{tblData.page}} , Showing {{(tblData.page - 1) * tblData.limit + 1}}
              to
              <span
                v-if="((tblData.page * tblData.limit)>tblData.total)"
              >{{tblData.total}}</span>
              <span v-else>{{tblData.page * tblData.limit}}</span>
              of {{tblData.total}} entries,
              <span
                class="ml-3 mr-1"
              >limit per page :</span>
              <select v-model="tblData.limit" style="width:60px;">
                <option>10</option>
                <option>15</option>
                <option>20</option>
                <option>25</option>
                <option>30</option>
              </select>
            </div>
          </b-col>
          <b-col cols="6">
            <b-pagination
              align="right"
              :total-rows="tblData.total"
              :per-page="tblData.limit"
              v-model="tblData.page"
            ></b-pagination>
          </b-col>
        </b-row>

  </div>
</template>
<style lang="scss">
  .lku-benefitEnttl {
    td {
      padding: 0;

      a {
        //   border: 1px solid;
        text-decoration: none;
        display: block;
        padding: 0.5rem 0.75rem;
      }
    }
  }
</style>

<script>
import benefitenttl from "../../apis/benefitenttl";
import toastr from "mini-toastr";
toastr.init();

export default {
  data() {
    return {
      fields: [
          {
            key: "crewname",
            label: "Employee",
            sortable: true
          },
          {
            key: "NmClaim",
            label: "Benefit Name",
            sortable: true
          },
          {
            key: "Periode",
            label: "Entitlement Period",
          },
          {
            key: "TotPlatform",
            label: "Total Plafon",
            thStyle: "width:110px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "TotalTaken",
            label: "Claimed",
            thStyle: "width:110px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "PlatfrmBlc",
            label: "Balance",
            thStyle: "width:110px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
      ],
      items:[],
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: null,
        sortDesc: false,
        outstand: '1',
      },
      updatetable:true,
      lkuLoading:true,
    };
  },
  computed: {
    filterCrewname() {
      return this.tblData.crewname;
    },
    filterCrewkey() {
      return this.tblData.crewkey;
    },
    filterClaimID() {
      return this.tblData.ClaimID;
    },
    filterNmClaim() {
      return this.tblData.NmClaim;
    },
    pagechange() {
      return this.tblData.page;
    },
    limitchange() {
      return this.tblData.limit;
    },
  },
  watch: {
    filterCrewname: function(newval) {
      this.$emit('update:crewname', newval);
    },    
    filterCrewkey: function(newval) {
      this.$emit('update:crewkey', newval);
    },   
    filterClaimID: function(newval) {
      this.$emit('update:ClaimID', newval);
    },    
    filterNmClaim: function(newval) {
      this.$emit('update:NmClaim', newval);
    },   
    pagechange: function(newval) {
      this.tblData.page=newval;
      this.refresh();
    },   
    limitchange: function(newval) {
      this.data();
    },   
  },
  props: ["crewname", "crewkey", 'ClaimID', 'NmClaim',"formdata"],
  created: async function() {
      this.tblData.crewname=this.crewname || '';
      this.tblData.crewkey=this.crewkey || '';
      this.tblData.ClaimID=this.ClaimID || '';
      this.tblData.NmClaim=this.NmClaim || '';
      if (this.crewkey) {
        if (this.formdata.items)
        {
          if (this.formdata.items[0].crewkey!==this.crewkey) {
            this.data();
          } else {
            for (var key in this.formdata) {
                this.tblData[key] = this.formdata[key];
            }
          }
        } else {
          this.data();
        }
      } else {
        if (this.formdata.items)
        {
            for (var key in this.formdata) {
                this.tblData[key] = this.formdata[key];
            }
        }
      }
  },
 methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    data: async function(ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      this.lkuLoading=true;
      const list = await benefitenttl.list(this.tblData);      
      this.lkuLoading=false;
      this.tblData.items=list;
      this.updatetable=!this.updatetable;
      // console.log('this.tblData : ',this.tblData);
    },
    selectItem(item,index) {
      // this.$emit("click", item);
      this.tblData.selected=item;
      this.$emit("click", this.tblData);
    },
    clearFilter() {
        this.crewname= '';
        this.crewkey=  '';
        this.ClaimID= '';
        this.NmClaim=  '';
        this.tblData.crewname= '';
        this.tblData.crewkey=  '';
        this.tblData.ClaimID= '';
        this.tblData.NmClaim=  '';
    },    
    keymonitor: function(event) {
       if(event.key == "Enter")
       {
        //  console.log('the id of the input was:' + event.currentTarget.id);
        this.$refs.tblAdvPay.refresh();
       }
    },    
    refresh() {
      this.data();
      this.$refs.tblAdvPay.refresh();
    }

  }
};
</script>
